/* ============================================================
   CELESTIAL VAULT — dual-handle price range slider
   Drives Dawn's existing From/To price inputs (so Shopify's
   native price filtering + AJAX re-render keep working).
   ============================================================ */
(function () {
  'use strict';

  function currencySymbol(root) {
    var cur = root.closest('details') || document;
    var el = cur && cur.querySelector('.field-currency');
    return el ? el.textContent.trim() : '£';
  }

  function enhance(rangeEl) {
    if (rangeEl.dataset.cvRangeInit === '1') return;
    rangeEl.dataset.cvRangeInit = '1';

    var lo = rangeEl.querySelector('[data-cv-range-min]');
    var hi = rangeEl.querySelector('[data-cv-range-max]');
    var fill = rangeEl.querySelector('.cv-range__fill');
    var labLo = rangeEl.querySelector('[data-cv-range-label-min]');
    var labHi = rangeEl.querySelector('[data-cv-range-label-max]');
    var priceBox = rangeEl.closest('details');
    if (!lo || !hi || !priceBox) return;

    var inputLo = priceBox.querySelector('input[name*=".gte"]');
    var inputHi = priceBox.querySelector('input[name*=".lte"]');
    var max = parseFloat(hi.max) || 100;
    var sym = currencySymbol(rangeEl);

    function paint() {
      var a = parseFloat(lo.value), b = parseFloat(hi.value);
      var left = (a / max) * 100, right = (b / max) * 100;
      fill.style.left = left + '%';
      fill.style.width = Math.max(0, right - left) + '%';
      if (labLo) labLo.textContent = sym + a;
      if (labHi) labHi.textContent = sym + b;
    }

    function clamp(which) {
      var a = parseFloat(lo.value), b = parseFloat(hi.value);
      if (a > b) {
        if (which === 'lo') lo.value = b; else hi.value = a;
      }
    }

    function commit() {
      // write into Dawn's price fields and let its facet AJAX take over
      var a = parseFloat(lo.value), b = parseFloat(hi.value);
      if (inputLo) inputLo.value = a > 0 ? a : '';
      if (inputHi) inputHi.value = b < max ? b : '';
      var target = inputHi || inputLo;
      if (target) {
        target.dispatchEvent(new Event('input', { bubbles: true }));
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    ['input'].forEach(function (evt) {
      lo.addEventListener(evt, function () { clamp('lo'); paint(); });
      hi.addEventListener(evt, function () { clamp('hi'); paint(); });
    });
    lo.addEventListener('change', commit);
    hi.addEventListener('change', commit);

    // keep slider in sync if the user types into the From/To fields
    [inputLo, inputHi].forEach(function (inp, i) {
      if (!inp) return;
      inp.addEventListener('change', function () {
        var v = parseFloat(inp.value);
        if (isNaN(v)) v = i === 0 ? 0 : max;
        (i === 0 ? lo : hi).value = Math.min(Math.max(v, 0), max);
        clamp(i === 0 ? 'lo' : 'hi');
        paint();
      });
    });

    paint();
  }

  function init() {
    document.querySelectorAll('[data-cv-range]').forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  var deb;
  new MutationObserver(function () { clearTimeout(deb); deb = setTimeout(init, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
